/**
 * Centralizes asset-lineage classification so every asset view applies the
 * same presentation policy without depending on UI or localization modules.
 */

const SMART_CROP_METHOD = 'smart-crop';
const OTHER_AUTOGEN_METHODS = new Set([
  'naive-crop',
  'html-template',
]);

export type AssetSourceLabel = 'AUTOGEN' | 'BOX' | 'VAULT';

export function isSmartCropAsset (
  generationMethods: readonly string[] | undefined,
): boolean {
  return generationMethods?.includes(SMART_CROP_METHOD) ?? false;
}

export function deriveAssetSourceLabel (
  generationMethods?: readonly string[],
): AssetSourceLabel | null {
  const methods = generationMethods ?? [];

  if (
    isSmartCropAsset(methods) ||
    methods.some((method) => OTHER_AUTOGEN_METHODS.has(method))
  ) return 'AUTOGEN';
  if (methods.includes('box')) return 'BOX';
  if (methods.includes('vault')) return 'VAULT';

  return null;
}
